import { useEffect, useRef } from 'react';

/**
 * 화면 진입(view) 이벤트를 한 번만 보낸다. `ready` 가 falsy 인 동안은 기다리고, 처음 truthy 가 된
 * 렌더 뒤에 그 값을 넘겨 `track` 을 부른다. `key` 가 바뀌면 그 key 로 한 번 더 보낸다.
 */
export function useTrackOnce<T>(
  ready: T | null | undefined | false,
  track: (value: T) => void,
  key = '',
) {
  const trackedKeyRef = useRef<string | null>(null);

  // 의존성 없이 매 렌더 뒤에 돌고 이미 보낸 key 면 바로 빠진다 — 렌더마다 새로 만든 함수를 넘겨도 된다.
  useEffect(() => {
    if (!ready || trackedKeyRef.current === key) return;
    trackedKeyRef.current = key;
    track(ready);
  });
}
